import { EchecApi } from '../partage/api/client';

/**
 * Pourquoi le serveur refuse de supprimer ce compte depuis l'app (décision 8 d'Igor du
 * 2026-10-21, chantier parametres-du-compte) : le premier compte, celui d'Igor, ou le dernier. Le
 * refus arrive en 403 `suppression_refusee`, sa raison dans `details` (`server/src/routes/mails.ts`).
 * Null : ce n'est pas ce refus-là. `inconnue` : refusé, sans raison qu'on sache dire.
 */
export type RaisonDuRefus = 'premier' | 'dernier' | 'inconnue';

export function raisonDuRefusDeSuppression(erreur: unknown): RaisonDuRefus | null {
  if (!(erreur instanceof EchecApi) || erreur.code !== 'suppression_refusee') return null;
  const raison = (erreur.details as { raison?: unknown } | undefined)?.raison;
  return raison === 'premier' || raison === 'dernier' ? raison : 'inconnue';
}
